import React from "react";
import PropTypes from "prop-types";
import { formatTime } from "../Misc/Utils";

var Timer = function Timer(_ref) {
  var time = _ref.time;
  return React.createElement("div", {
    className: "recorder__state"
  }, React.createElement("div", {
    className: "recorder__state-recording"
  }), React.createElement("div", {
    className: "recorder__state-time"
  }, formatTime(time)));
};

Timer.propTypes = process.env.NODE_ENV !== "production" ? {
  time: PropTypes.number.isRequired
} : {};
export default Timer;